'use strict';
const GRAPHQL_ENDPOINT = 'https://country-service.shopifycloud.com/graphql';

const query =
  'query countries($locale: SupportedLocale!) {' +
  '  countries(locale: $locale) {' +
  '    name' +
  '    code' +
  '    labels {' +
  '      address1' +
  '      address2' +
  '      city' +
  '      company' +
  '      country' +
  '      firstName' +
  '      lastName' +
  '      phone' +
  '      postalCode' +
  '      zone' +
  '    }' +
  '    formatting {' +
  '      edit' +
  '    }' +
  '    zones {' +
  '      name' +
  '      code' +
  '    }' +
  '  }' +
  '}';

function loadCountries() {
  const response = fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      query: query,
      operationName: 'countries',
      variables: {
        locale: 'EN',
      },
    }),
  });

  return response
    .then(function(res) {
      return res.json();
    })
    .then(function(countries) {
      return countries.data.countries;
    });
}

/**
 * Handles when a country change: set labels, reorder fields, populate zones
 */
function handleCountryChange(formElements, countryCode, countries) {
  // console.log('country', country);
  const country = getCountry(countryCode, countries);
  // console.log('country', country);
  populateZones(country);
}

/**
 * Sets up event listener for country change
 */
function setEventListeners(formElements, countries) {
  formElements.addEventListener('change', function(event) {
    handleCountryChange(formElements, event.target.value, countries);
  });
}

/**
 * Add right countries in the dropdown for a given country
 */
function populateCountries(formElements, countries) {
  const countrySelect = formElements;
  const duplicatedCountrySelect = countrySelect.cloneNode(true);

  countries.forEach(function(country) {
    // console.log('country', country);
    const optionElement = document.createElement('option');
    optionElement.value = country.code;
    optionElement.textContent = country.name;

    duplicatedCountrySelect.appendChild(optionElement);
  });

  countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;

  if (countrySelect.dataset.default) {
    countrySelect.value = countrySelect.dataset.default;
  }
}

/**
 * Add right zones in the dropdown for a given country
 */
function populateZones(country) {
  const stateEl = document.querySelector('[data-address-autofill-state-selecter]');
  if (!stateEl) {
    return;
  }

  if (country.zones.length === 0) {
    stateEl.closest('.js-state-selecter-wrap').classList.add('d-none');
    stateEl.closest('[data-form-field]').classList.remove('field--has-value');
    stateEl.required = false;
    // zoneEl.input.innerHTML = '';
    return;
  } else {
    stateEl.closest('.js-state-selecter-wrap').classList.remove('d-none');
    stateEl.closest('[data-form-field]').classList.add('field--has-value');
    stateEl.required = true;
  }

  // zoneEl.wrapper.dataset.ariaHidden = 'false';

  const zoneSelect = stateEl;
  const duplicatedZoneSelect = zoneSelect.cloneNode(true);
  duplicatedZoneSelect.innerHTML = '';

  country.zones.forEach(function(zone) {
    const optionElement = document.createElement('option');
    optionElement.value = zone.code;
    optionElement.textContent = zone.name;
    duplicatedZoneSelect.appendChild(optionElement);
  });

  zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;

  if (zoneSelect.dataset.default) {
    zoneSelect.value = zoneSelect.dataset.default;
  }
}

/**
 * Given an countryCode (eg. 'CA'), will return the data of that country
 */
function getCountry(countryCode, countries) {
  countryCode = countryCode || 'EN';

  return countries.filter(function(country) {
    return country.code === countryCode;
  })[0];
}

export const countryFormSelecter = countryFormEl => {
  return loadCountries().then(function(countries) {
    const selectedCountries = countries.filter(
      country => country.code === 'AU' || country.code === 'NZ'
    );

    const restOfTheWorld = {
      code: 'ROTW',
      formatting: { edit: null },
      labels: null,
      name: 'Rest of the world',
      zones: [],
    };
    selectedCountries.push(restOfTheWorld);

    populateCountries(countryFormEl, selectedCountries);
    setEventListeners(countryFormEl, selectedCountries);
  });
};
